var VrHeaderCategories = function(params) {
    var _this = this,
        _getCatAjaxUrl = '/brochures/related_by_city_brand',
        _catNavSel = '.vr-cat-nav-item',
        _jsLoadedClass = 'js-loaded',
        _defaultLimit = 8,
        _cachedCats = [];

    function _errorCallback(err) {
        console.log("ajax error: ", err);
    }

    function sendHeaderImpressionsStat(data) {
        var device = (isMobile || isTablet) ? 'mobile' : 'desktop';

        function createUUID() {
            return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };

        function setCookie(name, value, days) {
            var d = new Date;
            d.setTime(d.getTime() + 24*60*60*1000*days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
        }

        function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(";").shift();
        }

        if (document.cookie.indexOf('uid=') !== -1) {
            var uuid = getCookie('uid');
        } else {
            var uuid = createUUID();
            setCookie('uid', uuid, 365);
        }

        $.ajax({
            type: "POST",
            url: '/ajx/ajax.file.php',
            contentType: "application/json",
            data: JSON.stringify({
                impressions: data,
                device: device,
                userUuid: uuid,
                fn: "brochureImpressions"
            }),
            dataType: 'json',
            success: function(data){
                
            },
            error: function(err){}
        });
    }

    function _getRelatedBrochruesByCatAndCityId(categoryId, cityId, $el) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: _getCatAjaxUrl,
            success: function(data){
                _displayRelatedByCat(data, categoryId);
                $el.addClass(_jsLoadedClass);

                if (typeof offerista_tracking !== "undefined" && offerista_tracking) {
                    var relatedHeaderImpressions = new OfferistaTracking(),
                        relatedHeaderObjectsArray = [];

                    for (i=0; i<data.related_brochures.length; i++) {
                        var offerista_id = Number(data.related_brochures[i].offerista_id);

                        if (sentBrochureImpressionsArr.indexOf(offerista_id) === -1 && offerista_id !== 0) {
                            
                            sentBrochureImpressionsArr.push(offerista_id);
                            relatedHeaderObjectsArray[i] = (new OfferistaTracking()).data.trackings[0];
                            relatedHeaderObjectsArray[i].type = "BROCHURE_IMPRESSION";
                            relatedHeaderObjectsArray[i].objectId = offerista_id;
                        }
                    }

                    relatedHeaderImpressions.sendTracking({fn: "offeristaTracking", trackings: relatedHeaderObjectsArray});
                }

                if (typeof brochure_impression_statistics !== "undefined" && brochure_impression_statistics) {
                    var relatedHeaderObjectsStatArray = [];

                    for (i=0; i<data.related_brochures.length; i++) {
                        var id = Number(data.related_brochures[i].id);

                        if (sentBrochureImpressionsArray.indexOf(id) === -1 && id !== 0) {
                            
                            sentBrochureImpressionsArray.push(id);
                            relatedHeaderObjectsStatArray[i] = id;
                        }
                    }

                    sendHeaderImpressionsStat(relatedHeaderObjectsStatArray);
                }

            },
            error: _errorCallback,
            data: {
                limit: _defaultLimit,
                category_id: categoryId,
                city_id: cityId,
                brochure_id: brochureId
            }
        });
    }

    function _displayRelatedByCat(data, categoryId){
        // console.log("data", data);

        if (typeof data !== 'undefined' && data != '') {
            _cachedCats["cat_" + categoryId] = data;

            var _relatedCatWrapSel =  '.vr-cat-top-brands-inner-wrap',
                _relatedBrArr = [];
            
            $.each(data.related_brochures, function(inx, item){
                var _relatedBr = document.createElement('div');
                _relatedBr.className = 'vr-cat-related-br col-xs-6 col-sm-4 col-md-3 col-lg-5th';
                _relatedBr.innerHTML = '<a class="vr-cat-related-br__item" href="' + item.brochure_link + '" onclick="ga(\'send\', \'event\', \'brochure-view-' + (isMobile ? 'mobile' : 'desktop') +'\', \'similar-brochure-header-menu\', \'' + item.brochure_link + '\');">' +
                                        '<p class="vr-cat-related-br__title">' + item.brand_name + '</p>' + 
                                        // '<div class="vr-cat-related-br__back" style="background-image: url(' + item.cover + ');"></div>' + 
                                        '<img class="vr-cat-related-br__img" data-brochure-id="' + item.id + '" data-offerista-id="' + item.offerista_id + '" src="' + item.cover + '" alt="' + item.brand_name + '"/ >' +
                                        '</a>';
                
                _relatedBrArr.push(_relatedBr);
            });

            $(_relatedCatWrapSel).html(_relatedBrArr);
                // _populateCategoriesTopBrands(data, $el);
                // _populateCategoryImgAndTxt(data, $el);
        }
    }
    

    function _handleClicks(){
        $(document).on(isMobile ? 'click' : 'mouseenter', '.vr-cat-nav-wrap .vr-cat-nav-item', function(e){
            var $el = $(this),
                categoryId = $el.data('category-id'),
                categoryName = typeof viewVersion !== 'undefined' && viewVersion === '3' ? $el.text().trim() : $el.text().trim() + '-click',
                _catGaAction = typeof viewVersion !== 'undefined' && viewVersion === '3' ? 'header-menu-category' : 'similar-brochure-header-menu';

            $('.vr-cat-nav-wrap .vr-cat-nav-item').removeClass('vr-cat-nav-item_hovered');
            $el.addClass('vr-cat-nav-item_hovered');

            if($el.hasClass(_jsLoadedClass) == false){
                _getRelatedBrochruesByCatAndCityId(categoryId, city_id, $el);
            }else{
                _displayRelatedByCat(_cachedCats["cat_" + categoryId], categoryId, $el);
            }

            $('.vr-cat-top-brands__header-title').text($el.text().trim());
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), _catGaAction, categoryName);
        });
    }
    

    function _init() {
        _handleClicks();
    }

    _init();

    _this.init = _init;
};